import isEmpty from 'lodash/isEmpty';

// import paymentTypeToCreditCardType from '../../utils/paymentTypeToCreditCardType';

// https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-add_option
export default function payoutCardPrepareDataForRequest(formData) {
  const result = {
    updateOption: {
      type: formData.type,
      expirationMonth: formData.expirationMonth,
      expirationYear: formData.expirationYear,
    },
    address: {
      postalCode: formData.zipCode,
    },
  };

  if (isEmpty(formData.paymentOption)) {
    // creating new
    // result.updateOption.creditCardType = paymentTypeToCreditCardType(formData.cardType),
    result.updateOption.debitCardNumber = formData.cardNumber.replace(/\s/g, '');
    result.addOption = result.updateOption;
    delete result.updateOption;
  } // else no need to send cardNumber

  return result;
  // return {
  //   addOption: {
  //     type: 'CREDIT',
  //     creditCardType: paymentTypeToCreditCardType(formData.cardType),
  //     creditCardNumber: formData.cardNumber,
  //     expirationMonth: formData.expirationMonth,
  //     expirationYear: formData.expirationYear,
  //     clawback: formData.clawback,
  //   },
  //   address: {
  //     address1: formData.address1,
  //     city: formData.city,
  //     postalCode: formData.zipCode,
  //     countryAbbreviation: formData.countryAbbreviation,
  //     stateAbbreviation: formData.stateAbbreviation,
  //     unit: formData.unit,
  //     firstName: formData.firstName,
  //     lastName: formData.lastName,
  //     phone: formData.phone,
  //   },
  // };
}
